import axios from 'axios';
import { takeLatest, put } from 'redux-saga/effects';
import { actionCreator } from 'utils/action-creator';
import { shoppingBagActions } from './shopping-bag';
import { ShoppingBagCompleteActionTypes, ShoppingBagCompleteRequestAction, ShoppingBagCompleteSuccessAction, ShoppingBagCompleteFailureAction } from './shopping-bag.types';
import { landingActions } from '../landing/landing';

/**
 * Redux Actions
 */
export const shoppingBagCompleteActions = {
    request: actionCreator<ShoppingBagCompleteRequestAction>(ShoppingBagCompleteActionTypes.REQUEST),
    success: actionCreator<ShoppingBagCompleteSuccessAction>(ShoppingBagCompleteActionTypes.SUCCESS),
    failure: actionCreator<ShoppingBagCompleteFailureAction>(ShoppingBagCompleteActionTypes.FAILURE)
};

/**
 * Saga Functions
 */
export const sagas = {
    *request({ payload, resolve, reject }: ShoppingBagCompleteRequestAction) {
        try {
            const res = yield axios.post<{ success: true }>(`/shopping-bag/complete`);

            yield put(shoppingBagActions.complete(null));
            yield put(shoppingBagCompleteActions.success(null));

            yield put(landingActions.setItemsCount('0'));

            resolve!(res.data);
        } catch (err) {
            yield put(shoppingBagCompleteActions.failure(err.response.data.errors));
            reject!(err);
        }
    }
}

/**
 * Saga Watchers
 */
export const shoppingBagCompleteWatchers = function* () {
    yield takeLatest(ShoppingBagCompleteActionTypes.REQUEST, sagas.request)
}
